import { combineReducers } from 'redux';

import { authentication } from './authenticationReducer';
import { registration } from './registrationReducer';
import { users } from './usersReducer';
import { alert } from './alertReducer';
import { i18nReducer } from 'react-redux-i18n';

const rootReducer = combineReducers({
  authentication,
  registration,
  users,
  alert,
  i18n: i18nReducer
});

export default rootReducer;